export default __webpack_public_path__ + "static/media/706.f0c4dd64.png";